import { Injectable } from '@angular/core';
import { SessionService } from 'src/app/shared/session-service/session.service';
import { SurveyGridModel, SurveyGridHeaders } from 'src/app/shared/models/surveyDetails';
import { Employee } from 'src/app/data-analysis-summary/employee-information/employee-information.models';
import { API_URL } from 'src/app/shared/constants/apiurl-constants';
import { BehaviorSubject, Subject } from 'rxjs';
import { LoadingIndicatorService } from '@kpmg-tax/ui';
import { DeleteTimeSurveyRequest } from '../models/delete-survey-request.model';

@Injectable({ providedIn: 'root' })
export class SurveyDetailsService {
  surveys$ = new Subject<SurveyGridModel[]>();
  surveysGrid: SurveyGridModel[] = [];
  filteredSurveyGrid: SurveyGridModel[] = [];
  surveys: any;

  gridContents: any[] = [];
  gridMenus: any[] = [];
  gridHeaders: any[] = [];

  selectedEmployeesToDelete: any[] = [];
  selectedEmployees: Employee[] = [];
  employeeId: number;
  surveyId?: number;
  resolvedStatus: boolean = false;
  columntype: any;
  employeeName: any;
  reasons: any;
  docCount: number;
  roleId: number;
  longestEmpWord: string;
  employeeArray: any[] = [];
  descArray: any[] = [];
  costCenterDescArray: any[] = [];
  longestDescWord: string;
  costCenterDescFinalArray: any[] = [];
  employeefinalArray: any[] = [];
  descFinalArray: any[] = [];
  longDescWord: string = '';
  longEmpWord: string = '';
  UnAssignsmeSingleSurvey = new BehaviorSubject({});
  UnAssignsmeSingleSurveyCall = this.UnAssignsmeSingleSurvey.asObservable();
  selectedSMEs: any[] = [];
  savingInProcess: boolean = false;
  endTimer: number = 0;
  timeoutLength: number = 500;
  isTotalPercentage100: boolean = false;

  constructor(
    private _sessionService: SessionService,
    private _loaderService: LoadingIndicatorService,
  ) { }

  unAssignSmesSingle(remove: boolean) {
    this.UnAssignsmeSingleSurvey.next(remove);
  }

  // Checks if at least 1 employee has 100% to then activate the submit survey button
  checkTotalPercentage(){   
      if (this.surveys) {        
        this.isTotalPercentage100 = this.surveys.filter(x => x.projectTotal.value === 100).length > 0;
      }
  }

  loadSurveyDetails(surveyId: number, isClientSmeSurvey: boolean = false) {
    this.surveysGrid = [];
    this.employeefinalArray = [];
    this.descFinalArray = [];
    this.costCenterDescFinalArray = [];
    this._loaderService.display(true);
    let apiUrl =
      API_URL.SURVEY.GETSURVEYDETAILS +
      surveyId +
      '&engagementId=' +
      this.getEngagementId() + '&isClientSmeSurvey=' + isClientSmeSurvey;
    this._sessionService.apiUrlGet(apiUrl).subscribe((result: any) => {
      this.surveys = result.result;
      if (this.surveys) {

        /*  Get Survey Headers */
        this.gridHeaders = [];
        this.surveysGrid=[];
        for (let [key, value] of Object.entries(this.surveys[0])) {
          if (
            key !== 'comment' &&
            key !== 'reconciled' &&
            key !== 'status' &&
            key !== 'attachments'
          ) {
            /*--look for answer in backend for "=" and replace, in backend search for ConvertPropertyNameTypeToString--*/
            this.columntype = [];
            this.columntype = value;
            let item = {
              headerName: key.replace('=', ''),
              columnType: this.columntype.columnType,
              columnDesc: this.columntype.columnDesc
            };
            this.gridHeaders.push(item);
          }

        }
        let [txtBoxCnt, chkBoxCnt, displayText]: [number, number, string] = [0, 0, ''];
        if (this.gridHeaders.length > 0) {
          [txtBoxCnt, chkBoxCnt, displayText] = this.getSurveyTxtChkBoxCount(this.gridHeaders);
        }
        /*  Get Survey Details */
        this.surveys.forEach((element: any) => {
          this.gridContents = [];
          this.gridMenus = [];
          this.employeeArray = [];
          this.descArray = [];
          this.costCenterDescArray = [];
          for (let [key, value] of Object.entries(element)) {
            if (
              key !== 'comment' &&
              key !== 'reconciled' &&
              key !== 'status' &&
              key !== 'attachments'
            ) {
              this.gridContents.push(element[key]);
            } else {
              this.gridMenus.push(element[key]);
            }
            if (key == 'employee') {
              this.employeeArray.push(element[key]);
            }
            if (key == 'jobTitle') {
              this.descArray.push(element[key]);
            }
            if (key === 'costCenterDesc') {
              this.costCenterDescArray.push(element[key]);
            }
          }
          this.surveysGrid.push({
            gridContents: this.gridContents,
            gridHeader: this.gridHeaders,
            gridMenus: this.gridMenus,
            selected: false,
            checkBoxCount: chkBoxCnt,
            textBoxCount: txtBoxCnt,
            displayTextActivitiesProjects: displayText
          });
          this.employeefinalArray.push(this.employeeArray[0].value);
          this.descFinalArray.push(this.descArray[0].value);
          this.costCenterDescFinalArray.push(this.costCenterDescArray[0]?.value)
        });
        this.setLongestEmpWord(this.getLongestWord(this.employeefinalArray));
        this.setLongestDescWord(this.getLongestWord(this.descFinalArray));
        this.LongestCostCenterDesc = this.getLongestWord(this.costCenterDescFinalArray);
        this.employeefinalArray = [];
        this.descFinalArray = [];
        this.costCenterDescFinalArray = [];
      }
      this.filteredSurveyGrid = this.surveysGrid;
      this.surveys$.next(this.surveysGrid);
      this.checkTotalPercentage();
      this._loaderService.display(false);
    });

  }

  getSurveyTxtChkBoxCount(gridHeaders: SurveyGridHeaders[]): [number, number, string] {
    let chkCnt: number = 1;//--status column;
    let txtCnt: number = 0;
    let displayText = "";
    //--NQA + Total Allocatio + Total Qualified Allocation
    txtCnt = gridHeaders.filter(x => x.columnType === 1).length + 1 + 1;
    switch (this.SurveyTypeId) {
      case 1:
        chkCnt = chkCnt + gridHeaders.filter(x => x.columnType === 0).length;
        txtCnt = txtCnt + gridHeaders.filter(x => x.columnType === 3).length;
        displayText = "ACTIVITIES";
        break;
      case 2:
        chkCnt = chkCnt;
        txtCnt = txtCnt + gridHeaders.filter(x => x.columnType === 3).length;
        break;
      case 3:
        chkCnt = chkCnt + gridHeaders.filter(x => x.columnType === 3).length;
        txtCnt = txtCnt + gridHeaders.filter(x => x.columnType === 0).length;
        displayText = "PROJECTS";
        break;
      case 4:
        chkCnt = chkCnt + gridHeaders.filter(x => x.columnType === 3).length +
          gridHeaders.filter(x => x.columnType === 0).length;
        txtCnt = txtCnt + 1;//--Plus OQP
        displayText = "PROJECTS OR ACTIVITIES";
        break;
      case 5:
        chkCnt = chkCnt + gridHeaders.filter(x => x.columnType === 3).length;
        txtCnt = txtCnt + 1;//--Plus OQP
        displayText = "PROJECTS";
        break;
      case 6:
        chkCnt = chkCnt;
        txtCnt = txtCnt + gridHeaders.filter(x => x.columnType === 0).length;
        break;
      case 7:
        chkCnt = chkCnt + gridHeaders.filter(x => x.columnType === 0).length;
        txtCnt = txtCnt + 1;//--Plus OQP
        displayText = "ACTIVITIES";
        break;
      case 8:
        chkCnt = chkCnt;
        txtCnt = txtCnt + 1;//--Plus OQP
        break;
      default:
        chkCnt = 0;
        txtCnt = 0;
        break;
    }
    return [txtCnt, chkCnt, displayText]
  }

  getLongestWord(textArray: any[]) {
    let descfinalstr = textArray.join(' ')?.split(' ');
    let Longword: string;
    let longest2 = 0;
    for (let d = 0; d < descfinalstr?.length; d++) {
      if (longest2 < descfinalstr[d].length) {
        longest2 = descfinalstr[d].length;
        Longword = descfinalstr[d];
      }
    }
    return Longword;
  }

  setEmployeeId(employeeId: number) {
    this.employeeId = employeeId;
  }
  setSurveyId(surveyId: number) {
    this.surveyId = surveyId;
  }
  setLongestEmpWord(longestEmpWord: string) {
    this.longEmpWord = longestEmpWord;
  }
  getLongestEmpWord() {
    return this.longEmpWord;
  }
  setLongestDescWord(longestDescWord: string) {
    this.longDescWord = longestDescWord;
  }
  getLongestDescWord() {
    return this.longDescWord;
  }
  getEmployeeId() {
    return this.employeeId;
  }
  getSurveyId() {
    return this.surveyId;
  }
  getResolveStatus() {
    return this.resolvedStatus;
  }
  
  set SelectedSMEs(SMEs: any) {
    this.selectedSMEs = SMEs;
  }
  get SelectedSMEs(): any {
    return this.selectedSMEs;
  }

  private longCostCenterDesc: number;
  set LongestCostCenterDesc(desc: any) {
    this.longCostCenterDesc = desc;
  }
  get LongestCostCenterDesc(): any {
    return this.longCostCenterDesc;
  }

  private surveyTypeId: number;
  set SurveyTypeId(sTypeId: any) {
    this.surveyTypeId = sTypeId;
  }
  get SurveyTypeId(): any {
    return this.surveyTypeId;
  }

  resolveComment(surveyId: number, employeeId: number) {
    let resolveCommentsRequest = { EngagementId: this.getEngagementId(), SurveyId: surveyId, EmployeeId: employeeId };
    return this._sessionService.apiUrlPost(API_URL.COMMENTS.RESOLVECOMMENT, resolveCommentsRequest);
  }

  deleteMultipleSurveys(surveyIds: number[]) {
    let deleteTimeSurveysRequest: DeleteTimeSurveyRequest = { engagementId: this.getEngagementId(), timeSurveyIds: surveyIds }
    return this._sessionService.apiUrlPost(API_URL.SURVEY.DELETEMULTIPLESURVEYS, deleteTimeSurveysRequest);
  }

  isClientSMEView:boolean = false;
  studyId : number;  

  getEngagementId(): number {
    if(this.isClientSMEView){
      return this.studyId;
    }else{
      return Number(this._sessionService.getSession('engagementId'));
    }
  }

}
